// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-action-container {
  background-color: rgba(16, 16, 20, 0.9);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 100dvw;
  height: 100dvh;
  z-index: 109;
  display: flex;
  align-items: center;
  justify-content: center;
}
.confirm-action-container .confirm-action-container-card {
  background-color: #27272e;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  min-width: 200px;
  padding: 24px;
}
.confirm-action-container .confirm-action-container-card .confirm-action-container-card-bottons {
  display: flex;
  gap: 8px;
}
.confirm-action-container .confirm-action-container-card h2 {
  font-family: Plus Jakarta Sans;
  font-weight: 700;
  font-size: 22px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #fff;
}
.confirm-action-container .confirm-action-container-card button {
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/confirm-action/confirm-action.component.scss"],"names":[],"mappings":"AAAA;EACE,uCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EAEA,aAAA;AAAJ;AAEI;EACE,aAAA;EACA,QAAA;AAAN;AAGI;EACE,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AADN;AAII;EACE,kBAAA;AAFN","sourcesContent":[".confirm-action-container {\r\n  background-color: rgba($color: #101014d9, $alpha: 0.9);\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  max-width: 100dvw;\r\n  height: 100dvh;\r\n  z-index: 109;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  .confirm-action-container-card {\r\n    background-color: #27272e;\r\n    border-radius: 8px;\r\n    width: 90%;\r\n    max-width: 500px;\r\n    min-width: 200px;\r\n\r\n    padding: 24px;\r\n\r\n    .confirm-action-container-card-bottons {\r\n      display: flex;\r\n      gap: 8px;\r\n    }\r\n\r\n    h2 {\r\n      font-family: Plus Jakarta Sans;\r\n      font-weight: 700;\r\n      font-size: 22px;\r\n      line-height: 100%;\r\n      letter-spacing: 0%;\r\n      vertical-align: middle;\r\n      color: #fff;\r\n    }\r\n\r\n    button {\r\n      border-radius: 8px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
